import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-138321262-1'
})



// WEBPACK FOOTER //
// ./src/bibliotecas/vue/vueanalitics.js